/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { formatDateTime } from '../../../../../utils/dayJs/format'
import { AdminFranchise } from '../../../core/_models'

type Props = {
    franchise: AdminFranchise
}

const UpdatedInCell: FC<Props> = ({ franchise }) => (

    <div className='d-flex flex-column'>
        <a href='#' className='text-gray-800 text-hover-danger mb-1'>
            {franchise.updatedAt ? formatDateTime(franchise.updatedAt.toString()) : 'N/A'}
        </a>
        {/* <span>{franchise.updatedAt ? franchise.updatedAt.toString() : 'N/A'}</span> */}
    </div>
)

export { UpdatedInCell }
